import { TFunction } from 'i18next';
import { AccountType } from 'store/api/enums';

const USER_ACCOUNT_TYPE_KEYS = new Set([
  'OWNER',
  'STAFF',
  'CLIENT',
  'EXSTAFF',
  'SUPPORT',
  'ADMIN',
  'DDEXPERT',
  'UNSPECIFIED',
]);

const ACCOUNT_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  OWNER: 'users.account-type-owner',
  STAFF: 'users.user',
  CLIENT: 'users.account-type-client',
  EXSTAFF: 'users.account-type-ex-staff',
  SUPPORT: 'users.account-type-support',
  ADMIN: 'users.account-type-admin',
  DDEXPERT: 'users.account-type-dd-expert',
  UNSPECIFIED: 'users.account-type-unspecified',
};

export const getAccountTypeLabel = (
  accountTypeKey: string | undefined,
  t: TFunction
): string => {
  if (!accountTypeKey || !USER_ACCOUNT_TYPE_KEYS.has(accountTypeKey)) {
    return accountTypeKey
      ? AccountType[accountTypeKey as keyof typeof AccountType] ?? accountTypeKey
      : '-';
  }

  const translationKey = ACCOUNT_TYPE_TRANSLATION_KEYS[accountTypeKey];
  return translationKey ? t(translationKey) : accountTypeKey;
};
